import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortfolioComponent } from './portfolio.component';
import { RouterModule, Routes } from '@angular/router';
import { MasonryGridModule } from '../../../shared/components/masonry-grid/masonry-grid.module';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from "../../../shared/shared.module";

const ANGULAR_MATERIALS = [
  MatDividerModule
];

const CORE_MODULES = [CommonModule];

const COMPONENTS = [PortfolioComponent];

export const portfolio_nav_path = {};

const routes: Routes = [
  { path: '', component: PortfolioComponent, pathMatch: 'full' }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    ...CORE_MODULES, RouterModule.forChild(routes), ...ANGULAR_MATERIALS,
    MasonryGridModule, SharedModule
  ],
  exports: [...COMPONENTS]
})
export class PortfolioModule { }
